












import { Component, Vue, Prop } from "vue-property-decorator";
import { IAvailableTermMapped } from "@/models/providers/products";

@Component({
  components: {
    "product-term-card": () =>
      import(
        "@/components/app/global/baskets/basket/productView/productTermCard.vue"
      )
  }
})
export default class ProductTermCardGrid extends Vue {
  @Prop({ default: () => [] })
  public mappedTerms!: IAvailableTermMapped[];
}
